import { Button } from 'utils/Button';

const consultationBg =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/show/show18.webp';

export const LandingConsultation = () => {
  return (
    <div className="relative w-full min-h-[400px] sm:min-h-[450px] md:min-h-[500px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={consultationBg}
          alt="Oak and Stone Construction craftsmanship"
          className="object-cover w-full h-full"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative px-4 py-16 sm:py-20 w-full sm:px-6 lg:px-8">
        <div className="mx-auto max-w-[920px] text-center space-y-6 sm:space-y-8">
          <div className="space-y-3 sm:space-y-4">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-wide text-white uppercase md:text-4xl">
              Let's Start The Conversation
            </h2>
            <div className="mx-auto w-24 sm:w-32 h-1 bg-blue-500"></div>
            <p className="mx-auto max-w-3xl text-base sm:text-lg font-light md:text-xl text-white/90">
              Ask An Expert Today
            </p>
          </div>

          <p className="text-sm sm:text-base leading-relaxed md:text-lg text-white/80">
            At Oak and Stone Construction, we are dedicated to delivering
            quality and value. Everyone deserves a beautiful, comfortable home,
            and we're here to bring your vision to life with our expertise and
            experience. Contact us today to start your home remodeling journey!
          </p>

          <div className="pt-4">
            <Button
              text="REQUEST CONSULTATION"
              to="/contact"
              classname="bg-primary hover:bg-primary-hover text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-medium transition-all duration-200 transform hover:scale-[1.02]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
